<template>
  <div class="mt-10">
    <v-progress-circular v-if="loadingViewsAtivas" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
    <div v-else>
      <v-alert text color="teal" class="mb-4 mt-2">
        <v-row align="center" no-gutters>
          <v-col class="grow">
            <p>
              As abas abaixo exibem resultados de views escritas para encontrar potenciais erros na BDGD selecionada a fim de
              reportar problemas que podem afetar a execução da Etapa 17 do NVAL.
            </p>
            <p class="mb-0">
              O ideal é que estes potenciais erros sejam corrigidos antes de executar os testes da Etapa 17 na aba "GeoPerdas
              ANEEL".
            </p>
          </v-col>
        </v-row>
      </v-alert>

      <v-row no-gutters>
        <!-- Sidebar -->
        <v-col cols="12" md="3" lg="2" class="sidebar-col">
          <v-card outlined class="sidebar-card">
            <v-list dense nav class="pa-0">
              <v-subheader class="overline sidebar-subheader">
                <v-icon small left>mdi-table-search</v-icon>
                Validações ({{ viewsAtivas.length }})
              </v-subheader>
              <v-divider />
              <v-list-item-group v-model="selectedIndex" color="primary" mandatory>
                <v-list-item
                  v-for="(view, index) in viewsAtivas"
                  :key="view.id"
                  :value="index"
                  class="sidebar-item"
                  active-class="sidebar-item--active"
                >
                  <v-list-item-content>
                    <v-list-item-title :style="getStyle(view)">
                      <v-icon small :style="getStyle(view)">
                        {{ getIcon(view) }}
                      </v-icon>
                      {{ view.nome }}
                      <span v-if="view.count > 0">({{ view.count }})</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>

        <!-- Content area -->
        <v-col cols="12" md="9" lg="10" class="pl-md-4">
          <template v-if="viewSelecionada">
            <v-alert v-if="viewSelecionada.descricao" text color="info" class="mb-4 mt-0">
              <v-row align="center" no-gutters>
                <v-col class="grow">
                  <strong>{{ viewSelecionada.nome }}</strong>
                  ::
                  {{ viewSelecionada.descricao }}
                </v-col>
              </v-row>
            </v-alert>

            <diagnosticos-pre-etapa-17-data-table
              :key="viewSelecionada.id"
              :bdgdVersao="bdgdVersao"
              :viewDiagnostico="viewSelecionada"
            />
          </template>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import DiagnosticosPreEtapa17Service from '@/services/DiagnosticosPreEtapa17Service';
  import DiagnosticosPreEtapa17DataTable from './DiagnosticosPreEtapa17DataTable.vue';

  export default {
    name: 'DiagnosticosPreEtapa17',
    components: {
      DiagnosticosPreEtapa17DataTable
    },
    props: {
      bdgdVersao: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      selectedIndex: 0,
      loadingViewsAtivas: false,
      viewsAtivas: []
    }),
    computed: {
      viewSelecionada() {
        return this.viewsAtivas[this.selectedIndex] ?? null;
      }
    },
    mounted() {
      this.getViewsDiagnosticosPreEtapa17();
    },
    methods: {
      getViewsDiagnosticosPreEtapa17() {
        this.loadingViewsAtivas = true;
        this.selectedIndex = 0;
        DiagnosticosPreEtapa17Service.getViewsAtivas(this.bdgdVersao.id)
          .then(({ data }) => {
            this.viewsAtivas = data;
          })
          .catch((error) => {
            this.$toast.error('Erro ao buscar as views de diagnósticos ativas.', '', {
              position: 'topRight'
            });
            console.error(error);
          })
          .finally(() => (this.loadingViewsAtivas = false));
      },
      getStyle(view) {
        let color = this.$vuetify.theme.themes.light.success;
        if (view.count > 0) {
          color = 'orange';
        }
        return { color };
      },
      getIcon(view) {
        return view.count === 0 ? 'mdi-check-bold' : 'mdi-alert-outline';
      }
    },
    watch: {
      bdgdVersao() {
        this.getViewsDiagnosticosPreEtapa17();
      }
    }
  };
</script>

<style scoped>
  .sidebar-col {
    min-width: 0;
  }

  .sidebar-card {
    border-radius: 8px;
    overflow: hidden;
    position: sticky;
    overflow-y: auto;
  }

  .sidebar-subheader {
    font-size: 12px !important;
    letter-spacing: 0.08em;
    color: rgba(0, 0, 0, 0.54);
    height: 36px;
    padding: 0 16px;
  }

  .sidebar-item {
    margin-bottom: 4px;
    min-height: 42px;
    transition: background-color 0.15s ease;
  }

  .sidebar-item--active {
    background-color: rgba(var(--v-primary-base), 0.1);
    font-weight: 600;
  }

  .sidebar-item--active .sidebar-item-title {
    font-weight: 600;
  }
</style>
